import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import {
  FetchCompoundSettingsFailure,
  FetchCompoundSettingsRequest,
  FetchCompoundSettingsSuccess,
  UpdateCompoundSettingsFailure,
  UpdateCompoundSettingsRequest,
  UpdateCompoundSettingsSuccess,
} from './compound-settings.actions'
import { CompoundSettingsService } from './compound-settings.service'
import * as CompoundSettingsTypes from './compound-settings.types'

@Injectable()
export class CompoundSettingsEffects {
  constructor(
    private actions: Actions,
    private compoundSettingsService: CompoundSettingsService,
    private router: Router,
  ) {}

  FetchCompoundSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(CompoundSettingsTypes.FETCH_COMPOUND_SETTINGS_REQUEST),
      switchMap((action: FetchCompoundSettingsRequest) => {
        return this.compoundSettingsService.fetchCompoundSettings().pipe(
          map((result) => {
            return new FetchCompoundSettingsSuccess(result.data)
          }),
          catchError((err, caught) => {
            return of(new FetchCompoundSettingsFailure({ error: err }))
          }),
        )
      }),
    ),
  )

  UpdateCompoundSettings$ = createEffect(() =>
    this.actions.pipe(
      ofType(CompoundSettingsTypes.UPDATE_COMPOUND_SETTINGS_REQUEST),
      switchMap((action: UpdateCompoundSettingsRequest) => {
        return this.compoundSettingsService
          .updateCompoundSettings(action.payload)
          .pipe(
            switchMap((result) => {
              return [
                new UpdateCompoundSettingsSuccess(),
                new FetchCompoundSettingsRequest(),
              ]
            }),
            catchError((err, caught) => {
              return of(new UpdateCompoundSettingsFailure({ error: err }))
            }),
          )
      }),
    ),
  )
}
